import { render, staticRenderFns } from "./TwoFAForm.vue?vue&type=template&id=9be588e2"
import script from "./TwoFAForm.vue?vue&type=script&lang=js"
export * from "./TwoFAForm.vue?vue&type=script&lang=js"
import style0 from "./TwoFAForm.vue?vue&type=style&index=0&id=9be588e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports